import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // 验权

const whiteList = ['/login'] // 不重定向白名单

function addRoutesCompat(routes) {
  if (!Array.isArray(routes) || routes.length === 0) return
  if (typeof router.addRoute === 'function') {
    routes.forEach(route => {
      const copy = Object.assign({}, route)
      if (copy.children) {
        copy.children = copy.children.slice()
      }
      router.addRoute(copy)
    })
  } else if (typeof router.addRoutes === 'function') {
    router.addRoutes(routes)
  }
}

router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (store.getters.roles.length === 0) {
        store.dispatch('GetInfo').then(res => { // 拉取用户信息
          let menus=res.data.menus;
          let username=res.data.username;
          store.dispatch('GenerateRoutes', { menus,username }).then(() => { // 生成可访问的路由表
            addRoutesCompat(store.getters.addRouters) // 动态添加可访问路由表
            next({ ...to, replace: true })
          })
        }).catch((err) => {
          store.dispatch('FedLogOut').then(() => {
            Message.error(err || 'Verification failed, please login again')
            next({ path: '/' })
          })
        })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      // 带上原目标：登录页本来就支持 redirect（见 views/login/index.vue），这里以前没传，
      // 导致深链（例如手机上直达 AI 客服工作台的快捷方式）在会话过期后，
      // 登录完会掉到仪表盘，还得自己再点一遍进来。
      next(`/login?redirect=${encodeURIComponent(to.fullPath)}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js